import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function searchSettings(qryConds) {
  return Vue.http.get(api + 'set/list', { params: qryConds })
}

export function saveSetting(setting) {
  return Vue.http.post(api + 'set/save', setting)
}

export function getSettings(typeCode, setName) {
  return Vue.http.post(api + 'set/' + typeCode + '/' + setName, {})
}